import type { RecordOf } from 'immutable';
import { createSelector } from 'reselect';

import { REDUCER_KEY } from './rootUiReducer';
import type { RootUiData, RootUiStore } from './rootUiTypes';

export const getRootUiStore = (state: { [REDUCER_KEY]: RecordOf<RootUiStore> }) => state[REDUCER_KEY];
export const getRootUi = getRootUiStore;
export const getActiveModals = createSelector([getRootUiStore], (s) => s.activeModals);

export const getActiveModalsAsJS = createSelector(
  getActiveModals,
  (activeModals) => activeModals.toJS() as (Omit<RootUiData, 'props'> & { props: Record<string, any> })[],
);
